import { Container, injectable, type ServiceIdentifier, inject } from 'inversify';

export const container = new Container({ defaultScope: 'Singleton' });

export { injectable, inject };

export function getModule<T>(constructorFunction: ServiceIdentifier<T>, required: false): T | undefined;
export function getModule<T>(constructorFunction: ServiceIdentifier<T>, required: true): T;
export function getModule<T>(constructorFunction: ServiceIdentifier<T>): T;
export function getModule<T>(constructorFunction: ServiceIdentifier<T>, required = true): T | undefined {
  const module = container.getAll(constructorFunction)[0];

  if (required && !module) throw new Error(`Service / Controller '${String(constructorFunction)}' not found`);

  return module;
}

export function getAllModules<T>(constructorFunction: ServiceIdentifier<T>): T[] {
  return container.getAll(constructorFunction);
}

export function getNamedModule<T>(constructorFunction: ServiceIdentifier<T>, name: string | null, required: false): T | undefined;
export function getNamedModule<T>(constructorFunction: ServiceIdentifier<T>, name: string | null, required: true): T;
export function getNamedModule<T>(constructorFunction: ServiceIdentifier<T>, name: string | null): T;
export function getNamedModule<T>(constructorFunction: ServiceIdentifier<T>, name: string | null, required = true): T | undefined {
  if (!name) {
    // if no name is given we throw an error to satisfy the non-nullable return type
    if (required) {
      throw new Error(`Service not found '${String(constructorFunction)}' with name '${name}'`);
    }
    return;
  }

  let module;

  try {
    module = container.getAll(constructorFunction, { name })[0];

    return module;
  } catch (err: unknown) {
    if (err instanceof Error && err.message.includes('No matching bindings found')) {
      if (required) {
        throw new Error(`Service not found '${String(constructorFunction)}' with name '${name}'`);
      }

      return;
    }

    // log service can't be used here
    console.error('Error caught while initializing service', err);
  }
}

export function assertModuleMethod<T>(method: T, message: string): asserts method is NonNullable<T> {
  if (!method) throw new Error(message);
}

export function assertFeature(isEnabled: boolean, featureName: string): asserts isEnabled is true {
  if (!isEnabled) throw new Error(`${featureName} feature is not enabled`);
}
